import clsx from "clsx";
import { IUserinfo } from "../../types";
import Thumbnail from "../Thumbnail";

const UserInfo = ({
  withImage,
  title,
  subTitle,
  size,
  url,
  hasWidth,
  categories,
  userName,
}: IUserinfo) => {
  return (
    <section className="flex flex-row gap-3 items-center">
      {withImage && <Thumbnail size={size} url={url} />}
      <section className="flex flex-col gap-1 flex-grow">
        <h6 className="font-gt-w-medium m-0 p-0 text-base">
          {title} <span className="text-xs text-neutral-600">({userName})</span>
        </h6>

        <div className="flex items-center gap-1 mt-1">
          {categories?.map((item) => {
            return (
              <span
                className="flex px-[12px] py-[2px] font-gt-w-regular text-xs bg-[#ededed] rounded-full"
                key={item}
              >
                {item}
              </span>
            );
          })}
        </div>
      </section>
    </section>
  );
};

export default UserInfo;
